import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["tab", "panel", "prev", "next"];

  connect() {
    this.showPanel(this.activePanelId());
  }

  select(event) {
    event.preventDefault();
    const panelId = event.currentTarget.getAttribute("data-industry-tab");
    if (panelId) this.showPanel(panelId);
  }

  prev(event) {
    event.preventDefault();
    this.step(-1);
  }

  next(event) {
    event.preventDefault();
    this.step(1);
  }

  step(direction) {
    const ids = this.tabTargets.map((t) => t.getAttribute("data-industry-tab"));
    if (ids.length === 0) return;
    const currentId = this.activePanelId();
    const idx = ids.indexOf(currentId);
    const nextIdx = (idx + direction + ids.length) % ids.length;
    this.showPanel(ids[nextIdx]);
    const tab = this.tabTargets[nextIdx];
    if (tab && typeof tab.scrollIntoView === "function") {
      tab.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }
  }

  activePanelId() {
    const activeTab = this.tabTargets.find((tab) =>
      tab.classList.contains("is-active")
    );
    return (
      activeTab?.getAttribute("data-industry-tab") ||
      this.tabTargets[0]?.getAttribute("data-industry-tab")
    );
  }

  showPanel(panelId) {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.getAttribute("data-industry-tab") === panelId;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      if (isActive) {
        tab.setAttribute("aria-current", "true");
      } else {
        tab.removeAttribute("aria-current");
      }
    });

    this.panelTargets.forEach((panel) => {
      const isActive = panel.getAttribute("data-industry-panel") === panelId;
      panel.hidden = !isActive;
      panel.classList.toggle("is-active", isActive);
    });
  }
}
